import React from "react";
import { Link } from "react-router-dom";

// COMPONENTS
import Footer from "../components/utils/Footer";

export default function PrivacyPolicyView() {
	return (
		<section
			className="reading-section scrollable-container"
			style={{
				overflowY: "scroll",
			}}
		>
			<header>
				<div className="header-area header-transparrent">
					<div className="main-header header-sticky">
						<div className="container">
							<div className="row align-items-center">
								<div className="col-xl-2 col-lg-2 col-md-1">
									<div className="logo">
										<Link to="/">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="93"
												height="20"
												viewBox="0 0 93 20"
											>
												<title
													style={{
														backgroundColor: "transparent",
														border: "none",
													}}
												>
													keeano
												</title>
												<g fill="none" fillRule="evenodd">
													<g fill="#222C4B" fillRule="nonzero">
														<g>
															<path
																d="M70.392 4.62c-1.568-.032-3.059.683-4.015 1.926l-.077.1v-1.76h-2.473v14.78h2.57v-8.35c0-2.757 1.455-4.34 3.988-4.34 2.4 0 3.293 1.082 3.293 3.989v8.704h2.578v-8.704c0-2.067-.473-3.648-1.408-4.697-.974-1.093-2.47-1.647-4.456-1.647zM86.02 4.567c-4.276 0-6.933 2.956-6.933 7.714 0 4.758 2.657 7.713 6.932 7.713 4.276 0 6.936-2.955 6.936-7.713s-2.657-7.714-6.936-7.714zm0 13.019c-2.73 0-4.362-1.985-4.362-5.305 0-3.32 1.631-5.304 4.361-5.304 2.73 0 4.364 1.985 4.364 5.304 0 3.32-1.632 5.305-4.364 5.305zM7.393 11.495c.742-.563 1.421-1.202 2.028-1.907 1.15-1.364 2.08-2.898 2.756-4.55l.077-.178H9.482l-.035.074C8.32 7.247 6.827 8.968 5.01 10.049c-.727.44-1.52.76-2.35.945l-.052.01V0H0v19.658h2.608v-6.082h.038c.863-.122 1.698-.39 2.472-.79l.034-.016 4.886 6.893h3.16L7.36 11.519l.033-.024zM20.956 4.567c-2.193 0-4.03.742-5.31 2.147-1.258 1.374-1.922 3.321-1.922 5.622 0 2.259.658 4.169 1.901 5.526 1.28 1.394 3.123 2.138 5.33 2.138 3.032 0 5.406-1.496 6.526-4.106l-2.439-.849c-.086.176-.179.347-.235.458-.819 1.374-2.15 2.09-3.857 2.09-2.553 0-4.276-1.624-4.613-4.345v-.049h11.82v-.863c0-4.72-2.826-7.769-7.201-7.769zm-4.499 6.213l.013-.052c.48-2.348 2.159-3.751 4.486-3.751 2.29 0 3.952 1.403 4.456 3.751l.012.052h-8.967zM37.716 4.567c-2.195 0-4.031.742-5.313 2.147-1.256 1.374-1.919 3.321-1.919 5.622 0 2.259.657 4.169 1.9 5.526C33.664 19.256 35.506 20 37.716 20c3.022 0 5.394-1.489 6.517-4.088l-2.436-.844c-.085.176-.177.345-.227.44-.814 1.363-2.147 2.084-3.854 2.084-2.555 0-4.276-1.625-4.613-4.346v-.049h11.82v-.86c-.002-4.72-2.828-7.77-7.207-7.77zm-4.494 6.213l.01-.052c.485-2.348 2.163-3.751 4.484-3.751 2.29 0 3.95 1.403 4.457 3.751l.01.052h-8.961zM59.97 16.612v-6.456c0-1.799-.631-3.262-1.833-4.233-1.092-.887-2.63-1.356-4.443-1.356-2.947 0-4.974 1.927-5.813 3.578l-.061.119 2.22 1.041.058-.107c.232-.404.511-.78.83-1.12.743-.775 1.777-1.203 2.85-1.18 2.348 0 3.615 1.264 3.615 2.453v.18c-.062.816-2.256 1.187-4.086 1.356-1.895.18-3.391.672-4.445 1.463-1.14.86-1.72 1.968-1.72 3.294 0 2.65 1.914 4.3 4.996 4.3 2.525 0 4.275-.683 5.358-2.085l.049-.064.026.078c.378 1.159 1.423 1.797 2.94 1.797h.585v-2.415h-.61c-.477 0-.517-.49-.517-.643zm-2.57-4.244c0 1.782-.413 3.07-1.242 3.934-.829.864-2.052 1.278-3.747 1.278-1.585 0-2.693-.799-2.693-1.942 0-1.453 1.128-2.138 4.025-2.454 1.714-.18 2.89-.338 3.588-.85l.069-.051v.085z"
																transform="translate(-32.000000, -18.000000) translate(32.000000, 18.000000)"
															/>
														</g>
													</g>
												</g>
											</svg>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>

			<main>
				<div className="coverage section-padding">
					<div className="container">
						<div className="row">
							<div className="col-md-12 mx-auto">
								<div style={{ marginTop: "6rem" }}>
									<h1>Privacy Policy</h1>
								</div>

								<div className="legal-padding">
									<p>
										This Privacy Policy outlines Keeano’s policy and practices
										in compliance with the EU General Data Protection Regulation
										2016/679 (GDPR), and any applicable laws and regulations on
										the protection of personal data. It includes the types of
										personal data we process, the reasons and the legal basis
										for that processing, the technical and security measures
										that we apply and the rights that individuals have under
										GDPR.
									</p>
								</div>

								<p>
									The present Privacy Policy has been adopted by “KEEANO LTD”,
									having its registered office in Nicosia, Cyprus, at Metochiou
									73 Str., email:{" "}
									<a className="alink" href="mailto:contact@keeano.com">
										contact@keeano.com
									</a>
								</p>

								<h5>1. What is considered Personal Data?</h5>

								<p>
									Personal Data is any information that relates to you, or may
									be attributed to you. Such data is, for example, your name,
									surname, father’s name, address, postal code, city, country,
									country/region, telephone number, mobile phone number, as well
									as your email address, etc. Additionally, personal data also
									includes some technical data relating to you, such as your IP
									address or the devices from which you download and make use of
									our App, etc.
								</p>

								<h5>
									2. What types of Personal Data does Keeano collects and
									process?
								</h5>

								<p>
									Keeano collects those types of Personal Data that are
									necessary for the use of the App and our Services. Collection
									and processing of your Personal Data and details related to
									you takes place for purposes directly related to the use of
									the App and our Services and/or for purposes for which you
									have granted your explicit consent. Unless required or
									authorized by law, Keeano will not process sensitive personal
									information about you for purposes other than those for which
									the information was originally obtained or subsequently
									authorized by you, unless you have previously affirmatively
									and explicitly consent to this processing.
								</p>

								<p>
									Personal Data we collect about you is the necessary{" "}
									<strong>sign up information</strong> that is needed in order
									to provide you access to Keeano App and Services offered
									through the App, including your name, surname, email address,
									and account password.
								</p>

								<p>
									We also collect information about the{" "}
									<strong>devices, browsers and IP addresses</strong> you use to
									access Keeano App, in order to helps us provide you features
									like automatic product updates.
								</p>

								<p>
									We also collect the{" "}
									<strong>
										content that you optionally and willingly provide us
									</strong>
									, create, upload, or receive from others when using our
									Services. Specifically:
								</p>

								<ul>
									<li className="styli">
										You may, at your sole and absolute discretion, provide us{" "}
										<strong>
											Personal Data regarding your age, gender, marital status,
											number of your family’s members or your friends, passport
											or identification number, boating license, personal
											preferences and special needs,
										</strong>{" "}
										that help you enjoy all our Services and App’s features and
										personalize your experience with Keeano.{" "}
									</li>
									<li className="styli">
										You may also upload or post{" "}
										<strong>messages, photographs or comments,</strong> as well
										as interact and exchange data with other Keeano users.{" "}
									</li>
									<li className="styli">
										Finally, you may voluntarily provide us information about
										your location when you use our Services, which helps us
										offer features like directions or nearby spots of your
										interest. The types of <strong>location data</strong> we
										collect depend on your device and account settings. You can
										at any time turn your device’s location on or off at your
										sole and absolute discretion.{" "}
									</li>
								</ul>

								<p>
									You understand that you provide such types of your Personal
									Data to Keeano optionally and you explicitly consent to the
									collection and usage of them by us for purposes regarding the
									operation of the App. You shall have sole and absolute
									responsibility for the accuracy, quality, and legality of
									Personal Data you provide to Keeano.{" "}
								</p>

								<h5>
									3. Purposes and legal basis of Processing of Personal Data
								</h5>

								<p>
									Keeano endeavors to use your Personal Data only in ways that
									are compatible with the purposes for which we have collected
									them or subsequently authorized by you. We are taking
									reasonable steps designed to ensure that we collect Personal
									Data that is relevant to the App’s intended use, or otherwise
									reliable in relation to the purposes for which we have
									obtained the information, for as long as Keeano retains
									possession of such information.
								</p>

								<p>
									Keeano shall treat your Personal Data as strictly confidential
									and shall only process them in accordance with the
									requirements of the Data Protection Laws and Regulations. We
									will only process your Personal Data, where:
								</p>

								<ul>
									<li className="styli">
										the processing is necessary to provide our Services to you;
									</li>
									<li className="styli">
										you have given your consent to such processing (which you
										may withdraw at any time);
									</li>
									<li className="styli">
										the processing is necessary for compliance with our legal
										obligations (e.g. for compliance with tax obligations, or to
										enforce our legal rights); and/or
									</li>
									<li className="styli">
										the processing is necessary for our legitimate interests.{" "}
									</li>
								</ul>

								<p>
									<strong>Specifically,</strong> we may process your data for
									the following purposes:{" "}
								</p>

								<ul>
									<li className="styli">
										To provide and maintain Services offered through Keeano App.
									</li>
									<li className="styli">
										To allow you to participate and enjoy the various features
										and Premium Services of Keeano App, when you willingly
										decide to do so.
									</li>
									<li className="styli">
										To provide you customer support, when needed or requested by
										you.
									</li>
									<li className="styli">
										To monitor the usage of our App and detect, prevent and
										address technical issues
									</li>
									<li className="styli">
										To gather analysis or valuable information in order to
										improve our App.
									</li>
								</ul>

								<p>
									Finally, we may use your personal contact information to send
									you targeted marketing newsletters regarding our Services,
									which we believe may be of interest to you, only if you have
									explicitly requested and / or have given your consent to
									receive such newsletters from us.{" "}
								</p>

								<h5>
									4. Does Keeano transfer or disclose your Personal Data third
									parties?
								</h5>

								<p>
									Keeano does not and will not sell, rent out or trade your
									Personal Data. Access to your Personal Data shall only be
									provided to our duly authorized employees or business partners
									who act on our behalf for the above purposes of processing, by
									offering us IT or other services for the registration and
									storage of your data and/or for the operation of Keeano App.
									We will only disclose (transfer, share, send, or otherwise
									make available or accessible) your Personal Data to third
									parties in the ways set out in this Policy.
								</p>

								<p>
									We may disclose your Personal Data if required to do so by
									law, if disclosure is required to be made to law enforcement
									authorities, if we believe disclosure is necessary or
									appropriate to prevent vital individual’s interests (e.g. from
									physical harm) or in connection with an investigation of
									suspected or actual illegal activity.
								</p>

								<p>
									Your Personal Data are not transferred to countries outside
									the European Economic Area (EEA), to third countries and
									international organizations. In case we need to disclose your
									Personal Data to any overseas recipients, we will ensure that
									any such international transfers are made subject to
									appropriate or suitable safeguards as required by GDPR and any
									other applicable law.{" "}
								</p>

								<p>
									<strong>Specifically</strong>, we may transfer your Personal
									Data mainly at the following cases:
								</p>
								<ul>
									<li className="styli">
										To Google, especially for the use of the Google Analytics
										and Firebase Console
									</li>
									<li className="styli">
										To Microsoft, especially for the use of Microsoft Azure
									</li>
									<li className="styli">
										To external business advisers (such as lawyers and
										auditors);
									</li>
									<li className="styli">
										To service providers that host our customer database,
										perform its technical support and management;
									</li>
									<li className="styli">
										To mailing houses and courier companies;
									</li>
									<li className="styli">
										To government agencies and public authorities, regulatory
										bodies and enforcement agencies, to comply with a valid and
										authorized request, including a court order or other valid
										legal process, to protect against fraud and for related
										security purposes;
									</li>
									<li className="styli">
										To internal business parties (such as brokers, fleet
										operators, charter crew, etc) that you collaborate for your
										charter to satisfy your onboarding and on course charter
										processes and needs;
									</li>
									<li className="styli">
										As required or authorized by applicable law, and to comply
										with our legal obligations.
									</li>
								</ul>

								<h5>5. Appointment of Data Processors and Sub-Processors </h5>

								<p>
									You acknowledge and agree that Keeano may employ third party
									companies and individuals, agents, contractors or partners to
									facilitate the provision of its services related to Keeano App
									and provide part of these services on our behalf or to assist
									us in analyzing the use of our App, or to provide to us
									technical or legal support. These third parties, when
									appointed, are considered as Data Processors.
								</p>

								<p>
									In any such case, Keeano shall ensure that any third
									subscribes to the principles set hereby and is subject to
									applicable legal framework (including GDPR), providing the
									same level of privacy protection as required by the present
									Policy and agree in writing to provide an adequate level of
									privacy protection.
								</p>

								<p>
									Keeano shall be liable for the acts and omissions of its
									Processors and Sub-Processors regarding the protection of your
									Personal Data to the same extent Keeano would be liable if
									performing the services directly.
								</p>

								<h5>
									6. Security measures for the Protection of your Personal Data
								</h5>

								<p>
									We are committed to safeguarding and protecting your Personal
									Data and will implement and regularly review appropriate
									technical and organizational measures to ensure such level of
									security appropriate to protect any Personal Data provided to
									us. We consistently apply such measures in order to prevent
									accidental or unlawful destruction, loss, alteration,
									unauthorized disclosure, or access to your Personal Data
								</p>

								<p>
									Keeano operates in compliance with strict policies and
									procedures and employs reasonable electronic, managerial and
									technical procedures to safeguard and secure your Personal
									Data. All office computer and mobile devices are using the
									latest OS and updated security suites. Databases and all kind
									of storage are stored in a cloud provider with maximum
									security level. E-mail is served by dedicated e-mail server
									and there is an SSL security protocol for secure communication
									with our clients and secure file transfer. For filing our
									customers, pricing our services and keeping records regarding
									our storage we use SAP database, which provides us
									flexibility, security and quality in performing our
									activities.
								</p>

								<h5>7. Data retention</h5>

								<p>
									We will not retain any Personal Data longer than necessary to
									fulfil the purposes for which it was collected, unless the law
									requires us to hold your Personal Data for a longer period, or
									delete it sooner, or unless you exercise your right to have
									the information erased (where it applies) and we do not need
									to hold it in connection with any of the reasons permitted or
									required under the law.
								</p>

								<h5>8. Your rights</h5>

								<p>
									Keeano ensures that you can exercise all of your rights under
									GDPR in relation to your Personal Data that Keeano holds and
									processes. You also have the right to submit a complaint to
									the competent authority (Office of the Commissioner of the
									Protection for Personal Data Protection of Cyprus - P.O. Box
									23378, 1682 Nicosia, Cyprus –
									commissioner@dataprotection.gov.cy).{" "}
								</p>

								<p>Specifically, upon your request we will:</p>
								<ul>
									<li className="styli">
										allow access to copies of your Personal Data within a
										reasonable timeframe;
									</li>
									<li className="styli">
										correct your Personal Data where inaccurate;
									</li>
									<li className="styli">
										withdraw a previously provided consent to processing of your
										Personal Data etc
									</li>
									<li className="styli">
										get free access to your Personal Data (depending on the
										volume of data, we may ask you to cover some of our costs).
									</li>
								</ul>

								<p>
									If you wish to exercise any of your rights with respect to
									your Personal Data, you may inform us in writing at{" "}
									<a href="mailto:support@keeano.zendesk.com"></a>
									support@keeano.com.
								</p>

								<h5>9. Changes to this Privacy Policy</h5>

								<p>
									This Privacy Policy may change from time to time according to
									relevant legislation without prior notice. The "LAST UPDATED"
									section at the bottom of this page states when this Policy was
									last revised.
								</p>

								<h5>10. Cookies Policy</h5>

								<p>
									We use cookies in order to deliver and improve our services
									and customize your experience. To find out more about the
									cookies we use, see our{" "}
									<a className="alink" href="cookies-policy.html">
										Cookies Policy
									</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</main>

			<div className="container" style={{}}>
				<Footer />
			</div>
		</section>
	);
}
